export default {
  setLiveLocalData(state, data) {
    state.liveLocal[data.id] = data.liveLocalData
  },
  setLiveLocalCategories(state, value) {
    state.livelocalCategories = value
  },
  setContentFromTridion(state, value) {
    state.contentFromTridion = value
  },
  setLiveLocalManagementBookingData(state, value) {
    state.liveLocalManagement = value
  },
  setLiveLocalManagementContentData(state, value) {
    state.liveLocalData = value
  }
}
